// Module
var code = "<h2 id=\"loan-payoff\">Loan Payoff</h2> <p>Prepare to make that final payment and put your student loans behind you.</p> ";
// Exports
export default code;